import { useCallback } from 'react';
import { NotificationModel, notificationsClient, GetNotificationsOptions } from '@bymason/controller-api';
import { useDeleteDataWithResponseHook, useGetDataHook } from '@bymason/api-hooks-base';

export { NotificationResponse, NotificationModel } from '@bymason/controller-api';

/**
 * React hook that asynchronously gets all conifgured Notifications.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetNotifications(clientToken: string) {
  const handleGetData = useCallback(
    (options: GetNotificationsOptions) => {
      return notificationsClient.getNotifications(options, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously deletes a Notification by id
 * @returns HookArray
 * @HookArray [0] delete method
 * @HookArray [1] result
 * @HookArray [1] error
 * @HookArray [2] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useDeleteNotification(clientToken: string) {
  const handleGetData = useCallback(
    (id: string) => {
      return notificationsClient.deleteNotification(id, clientToken);
    },
    [clientToken]
  );
  return useDeleteDataWithResponseHook(handleGetData);
}

/**
 * React hook that asynchronously creates Notification.
 * @returns HookArray
 * @HookArray [0] post method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useCreateNotification(clientToken: string) {
  const handleGetData = useCallback(
    (options: NotificationModel) => {
      return notificationsClient.createNotification(options, clientToken);
    },
    [clientToken]
  );
  return useGetDataHook(handleGetData);
}
